import './index.css'
import Header from '../Header'
import ThemeContext from '../ThemeContext'
import LeftPortion from '../LeftPortion'

const NotFound = () => (
  <ThemeContext.Consumer>
    {value => {
      const {activeThemeIsLight} = value
      const theme = activeThemeIsLight ? 'light-theme' : 'dark-theme'
      const imageUrl = activeThemeIsLight
        ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-not-found-light-theme-img.png'
        : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-not-found-dark-theme-img.png'

      return (
        <>
          <Header />
          <div className="page-container">
            <LeftPortion />
            <div className={`content-container ${theme}`}>
              <div className="not-found-view">
                <img
                  alt="not found"
                  className="not-found-image"
                  src={imageUrl}
                />
                <h1>Page Not Found</h1>
                <p>We are sorry, the page you requested could not be found.</p>
              </div>
            </div>
          </div>
        </>
      )
    }}
  </ThemeContext.Consumer>
)

export default NotFound
